import { IAPIBOPISInventory } from './BOPISApiInterfaces';

export class InventoryCacheService {
    private ssNamespace: string = 'BOPIS';
    private expirationTime: number = 15 * 60000;
    private ssKeys = {
        inventory: '+inventory',
        expires: '+expires'
    };

    public setSSInventory(args: object, data: IAPIBOPISInventory) {
        const inventoryKey = this.getSSInventoryKey(args);
        sessionStorage.setItem(inventoryKey, JSON.stringify(data));
        this.setSSExpires();
    }

    //use to emulate server delay and not fall of async flow
    public async getSSInventoryAsync(args: object): Promise<IAPIBOPISInventory> {
        return new Promise((resolve) => {
            setTimeout(() => resolve(this.getSSInventory(args)), 0);
        });
    }

    public getSSInventory(args: object) {
        if (this.isSSCacheActive()) {
            const inventoryKey = this.getSSInventoryKey(args);
            const data = sessionStorage.getItem(inventoryKey);

            if (!data) {
                return undefined;
            }

            return JSON.parse(data);
        }

        return undefined;
    }

    private isSSCacheActive() {
        const expires = sessionStorage.getItem(this.getSSExpiresKey());

        if (!expires) {
            return false;
        }
        const isExpired = Date.now() > parseInt(expires, 10);
        if (isExpired) {
            Object.keys(sessionStorage).forEach((key) => {
                if (key.indexOf(`${this.ssNamespace}${this.ssKeys.inventory}`) === 0) {
                    sessionStorage.removeItem(key);
                }
            });

            return false;
        }

        return true;
    }

    private setSSExpires() {
        const key = this.getSSExpiresKey();
        sessionStorage.setItem(key, JSON.stringify(Date.now() + this.expirationTime));
    }

    private getSSInventoryKey(args: object) {
        return `${this.ssNamespace}${this.ssKeys.inventory}+${Object.values(args).join('+')}`;
    }

    private getSSExpiresKey() {
        return this.ssNamespace + this.ssKeys.expires;
    }
}
